import {hasBrowserWindowAccess} from "@buildwithflux/shared";
import isbot from "isbot";

/**
 * Detects if the current user agent is a bot
 *
 * This function uses the isbot library to determine if the current user agent
 * is a bot or crawler. It only performs the check if we have access to the browser
 * window (to avoid issues in server-side rendering environments).
 *
 * @returns {boolean} True if the current user agent is detected as a bot, false otherwise
 *
 * @example
 * // Check if current agent is a bot
 * if (currentAgentIsBot) {
 *   // Handle bot-specific behavior
 * }
 */
function detectIfIsBot(): boolean {
    return hasBrowserWindowAccess() && Boolean(isbot(navigator.userAgent));
}

/**
 * Constant indicating whether the current user agent is a bot
 * This is evaluated once at module load time
 */
export const currentAgentIsBot = detectIfIsBot();
